/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetSeatmapsResponseDataSeatmapsDecksInnerSeats } from './getSeatmapsResponseDataSeatmapsDecksInnerSeats';
import { GetSeatmapsResponseDataSeatmapsDecksInnerColumnsInner } from './getSeatmapsResponseDataSeatmapsDecksInnerColumnsInner';

export interface GetSeatmapsResponseDataSeatmapsDecksInner {
  /**
   * デッキの位置情報<br/> main：1F<br/> upper：2F
   */
  deckType: GetSeatmapsResponseDataSeatmapsDecksInner.DeckTypeEnum;
  /**
   * 列情報のリスト。座席列と通路列が含まれる。<br/> 通路列については座席情報の通路側characteristicを持つ席を基に、DxAPIより返却された列情報リストを左方向、右方向からそれぞれ繰り返し、最初にcharacteristicコードが“A”(通路席)または“WA”(窓際かつ通路席)の後に挿入する。ただし左通路と右通路が同じ位置となる場合は、挿入する通路は1つにする。
   */
  columns: Array<GetSeatmapsResponseDataSeatmapsDecksInnerColumnsInner>;
  /**
   * 通路数<br/> 列情報リストの通路数から算出する。
   */
  numberOfAisle: number;
  seats: GetSeatmapsResponseDataSeatmapsDecksInnerSeats;
}
export namespace GetSeatmapsResponseDataSeatmapsDecksInner {
  export type DeckTypeEnum = 'upper' | 'main';
  export const DeckTypeEnum = {
    Upper: 'upper' as DeckTypeEnum,
    Main: 'main' as DeckTypeEnum,
  };
}
